import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { MenuModule } from 'primeng/menu';
import { PanelModule } from 'primeng/panel';
import { Member } from '../../../../model/member';

import { CommonModule } from '@angular/common';
import moment from 'moment';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { MemberRegisterComponent } from '../member-register/member-register.component';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../../../environments/environment';
@Component({
  selector: 'app-member-information',
  standalone: true,
  imports: [PanelModule,AvatarModule,AvatarGroupModule,ButtonModule,MenuModule,DividerModule,ChipModule, CommonModule, MemberRegisterComponent, TagModule, ToastModule, ConfirmDialogModule],
  providers: [MessageService, ConfirmationService],
  templateUrl: './member-information.component.html',
  styleUrl: './member-information.component.scss'
})
export class MemberInformationComponent implements OnInit{

  items: MenuItem[] | undefined;
  isCollapsed:boolean = false;

  @Input()
  member!:Member;
  showMemberEditForm:boolean = false;

  @Output()
  memberUpdated:EventEmitter<Member> = new EventEmitter<Member>();

  @Output()
  memberDeleted:EventEmitter<Member> = new EventEmitter<Member>();

  isAdmin: boolean = false;

  constructor(private messageService: MessageService, private confirmationService: ConfirmationService, private msalService: MsalService) { }
  ngOnInit(): void {
    this.checkAdminRole();
    this.items = [
      {
          label: 'Editar',
          icon: 'pi pi-fw pi-pencil',
      },
  ];
  }

  checkAdminRole(): void {
    const userRoles: string[] = this.msalService.instance.getActiveAccount()?.idTokenClaims?.roles || [];
    this.isAdmin = userRoles.includes(environment.roles.adminRole);
  }

  calculateYearsOld(birthDay: string) {
    return moment().diff(birthDay, 'years');
  }

  initMemberEdit(member:Member){
    this.showMemberEditForm = true;
  }

  refreshMemberUpdated(member:Member){
    this.member = member;
    this.showMemberEditForm = false;
    this.memberUpdated.emit(member);
  }

  closeEditDialog(){
    this.showMemberEditForm = false;
  }

  confirmMemberDeletion(member: Member) {
    this.confirmationService.confirm({
      message: '¿Estás seguro de que deseas eliminar este miembro?',
      accept: () => {
        if (member.memberType === 'EXTERNAL' || this.isAdmin) {
          this.memberDeleted.emit(member);
        }
      }
    });
  }

  canDeleteMember(member: Member): boolean {
    return member.memberType === 'EXTERNAL' || this.isAdmin;
  }

}
